<template>
  <div class="container">
    <div class="topbg">
      <div class="title_img">
        <img src="../../assets/fangyi/biggifttitle.png" alt="" />
      </div>
      <div class="text_info">
        <div class="rule">
          <div class="title">
            <img src="../../assets/fangyi/arrow.png" alt />
            <span>活动规则：</span>
          </div>
          <div class="body">
            <div>(1).本次礼包领取活动的开始时间为正月十一（2月11日）。</div>
            <div>(2).本平台各类融资产品的审批权及解释权归相关银行所有。</div>
            <div>
              (3).本次礼包发放的优惠券在贷款成功后才能使用，兑现方式和规则的最终解释权归各银行所有，详情请咨询相关银行。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- <div
        :class="item.count == 30 ? 'gift_item goldbg' : 'gift_item redbg'"
        v-for="(item, index) in couponList"
        :key="index"
      >
        <dir class="left">
          <img src="../../assets/fangyi/juan.png" alt="" />
          <span>{{ item.couponType }}</span>
        </dir>
        <div class="right">{{ item.couponName }}</div>
      </div> -->
      <div class="gift_item goldbg">
        <dir class="left">
          <img src="../../assets/fangyi/juan.png" alt="" />
          <span>限量免息券</span>
        </dir>
        <div class="right">享受30天免息优惠 （仅限100张）</div>
      </div>
      <div class="gift_item redbg">
        <dir class="left">
          <img src="../../assets/fangyi/juan.png" alt="" />
          <span>利率尊享券</span>
        </dir>
        <div class="right">最多可享0.5%利率优惠</div>
      </div>
      <div class="gift_item redbg">
        <dir class="left">
          <img src="../../assets/fangyi/juan.png" alt="" />
          <span>利率优惠券</span>
        </dir>
        <div class="right">享受多款产品利率优惠</div>
      </div>
      <div class="gift_item redbg">
        <dir class="left">
          <img src="../../assets/fangyi/juan.png" alt="" />
          <span>产品优享券</span>
        </dir>
        <div class="right">享受特定产品优享优惠</div>
      </div>
      <div class="gift_item redbg">
        <dir class="left">
          <img src="../../assets/fangyi/juan.png" alt="" />
          <span>利率免息券</span>
        </dir>
        <div class="right">享受限时免息优惠</div>
      </div>
      <div class="gift_item redbg">
        <dir class="left">
          <img src="../../assets/fangyi/juan.png" alt="" />
          <span>信易贷专享券</span>
        </dir>
        <div class="right">享受多重专享优惠</div>
      </div>
      <div class="btn_box">
        <div class="btn" @click="getLibao">领取礼包</div>
      </div>
    </div>
    <el-dialog
      width="686px"
      :visible.sync="libaoVisible"
      custom-class="libaoDialog"
      :show-close="false"
      :destroy-on-close="true"
      :lock-scroll="false"
      :modal-append-to-body="true"
    >
      <img src="../../assets/newyearimg/libao.png" alt />
      <span @click="getLibao2">点击领取</span>
    </el-dialog>
    <el-dialog
      width="400px"
      :visible.sync="libaoVisible2"
      custom-class="libaoDialog"
      :show-close="false"
      :destroy-on-close="true"
      :lock-scroll="false"
      :modal-append-to-body="true"
    >
      <div>
        <h2>请扫码下载苏商通APP领取礼包</h2>
        <img src="../../assets/newyearimg/saoma.png" alt />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCouponList } from "@/api/fangyi";
export default {
  data() {
    return {
      couponList: [],
      libaoVisible: false,
      libaoVisible2: false,
    };
  },
  created() {
    // getCouponList().then((res) => {
    //   res = this.paramDecrypt(res);
    //   console.log(res);
    //   this.couponList = res.data;
    // });
  },
  methods: {
    getLibao() {
      this.libaoVisible2 = true;

      // const token = sessionStorage.getItem("token");
      // if (token) {
      // } else {
      //   this.$message.error("请先登录");
      //   this.$router.push("/xyd/login");
      //   return;
      // }
    },
    getLibao2() {
      this.libaoVisible = false;
      this.libaoVisible2 = true;
    },
  },
};
</script>

<style lang='less' scoped>
.container {
  position: relative;
  // background: #DE1E33;
  background: #de1e33;
  .topbg {
    width: 100%;
    height: 545px;
    background-image: url("../../assets/fangyi/biggifttopbg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position-y: -50px;
    .title_img {
      width: 1015px;
      margin: 0 auto;
      padding: 100px;
      img {
        width: 100%;
      }
    }
  }
  .text_info {
    width: 800px;
    margin: 0 auto;
    position: relative;
    top: -110px;
    .rule {
      padding: 0 50px 30px;
      .title {
        display: flex;
        align-items: center;
        font-weight: 500;
        margin-top: 20px;
        margin-bottom: 15px;
        img {
          width: 20px;
          margin-right: 8px;
          position: relative;
          top: 2px;
        }
        span {
          color: #fbebd4;
          font-size: 20px;
          font-weight: 700;
          font-family: "微软雅黑";
        }
      }
      .body {
        div {
          font-size: 16px;
          color: white;
          //   font-weight: bold;
          margin-bottom: 13px;
          letter-spacing: 1px;
          //   text-indent: 1em;
          line-height: 22px;
        }
      }
    }
  }
  .content {
    position: relative;
    top: -30px;
    width: 720px;
    //   height: 500px;
    margin: 0 auto;
    .goldbg {
      background-image: url("../../assets/fangyi/goldbg.png");
    }
    .redbg {
      background-image: url("../../assets/fangyi/redbg.png");
    }
    .gift_item {
      box-sizing: border-box;
      width: 710px;
      height: 121px;
      line-height: 80px;
      padding-bottom: 20px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      .left {
        width: 220px;
        margin-right: 60px;
        img {
          vertical-align: middle;
          margin-right: 10px;
        }
        span {
          color: #ffdbb4;
          font-size: 25px;
          vertical-align: middle;
        }
      }
      .right {
        font-size: 22px;
      }
    }
    .btn_box {
      width: 100%;
      padding-bottom: 50px;
      .btn {
        width: 270px;
        height: 100px;
        margin: 0 auto;
        background-image: url("../../assets/fangyi/btn.png");
        background-size: 100% 100%;
        font-weight: 500;
        color: #d50d0f;
        font-size: 24px;
        text-align: center;
        line-height: 110px;
        cursor: pointer;
      }
    }
  }
  /deep/.libaoDialog {
    background: unset;
    box-shadow: unset;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      position: relative;
      div {
        background: white;
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        h1 {
          color: black;
          text-align: center;
        }
      }
      img {
        width: 100%;
      }
      span {
        position: absolute;
        left: 240px;
        top: 480px;
        font-size: 35px;
        color: #d50d0f;
        font-weight: 550;
        background: linear-gradient(-88deg, #fed14b, #fcd167, #ffe8b0, #fdefc8);
        padding: 20px 40px;
        border-radius: 40px;
        cursor: pointer;
      }
    }
  }
}
</style>